import colors from "../colors";

export default colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Set2.js
// module id = 203
// module chunks = 0